<button pButton type="button" class="atlas-btn atlas-btn-primary tall" type="button" (click)="addAddress()"
  title="{{ 'common.add' | translate | titlecase }}">
  {{ 'common.add' | translate | titlecase }}
</button>
<ul class="list-unstyled">
  <li *ngFor="let address of value; index as i">
    <div class="flex column w-100" *ngIf="address.AddressTypeID !== 1">
      <div class="flex row content-end w-100" style="margin: 10px 0;">
        <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button" (click)="deleteAddress(i)"
          title="{{ 'common.delete' | translate | titlecase }}">
          {{ 'common.delete' | translate | titlecase }}
        </button>
      </div>
      <div>
        <wl-profile-edit-address [(ngModel)]="value[i]"></wl-profile-edit-address>
      </div>
    </div>
  </li>
</ul>